import { EventSourceParserStream } from "eventsource-parser/stream";
import log from "logbeacon";

export async function* parseSSEStream(stream: ReadableStream) {
  const sseStream = stream
    // eslint-disable-next-line no-undef
    .pipeThrough(new TextDecoderStream())
    .pipeThrough(new EventSourceParserStream());

  const reader = sseStream.getReader();
  let done = false;

  while (!done) {
    const res = await reader.read();
    const { value, done: doneReading } = res;

    done = doneReading;

    // ✅ 检查是否是错误事件
    if (value?.event === "error") {
      let errorCode = "";

      if (value?.data) {
        try {
          // 解码 base64 数据获取错误码
          errorCode = decodeURIComponent(escape(atob(value.data)));
          log.error(
            "[parseSSEStream] SSE error event received",
            `Error Code: ${errorCode}`,
          );
        } catch (decodeError) {
          log.error(
            "[parseSSEStream] Failed to decode error data",
            decodeError,
          );
          throw new Error("SSE Stream Error: Failed to decode error data");
        }
      }

      // 直接抛出包含错误码的错误
      throw new Error(errorCode || "SSE Stream Error");
    }

    // 后端做base64编码，防止空格/换行的异常传输
    // eslint-disable-next-line no-undef
    log.debug(
      "[parseSSEStream] value",
      value?.data,
      decodeURIComponent(escape(atob(value?.data || ""))),
    );
    yield value?.data ? decodeURIComponent(escape(atob(value.data))) : "";
  }
}
